import React from 'react'

import { connect, mapStateToProps, mapDispatchToProps } from '../../../../../reducers/Dispatchers'
import SectionsSubCell from './SectionsSubCell'

import '../../assets/places-definition.scss'
import PartialHandlerSubCell from './PartialHandlerSubCell'
import PausesSubCell from './PausesSubCell'

const SELECTED_CLASS = 'selected-cell'

const RegularCell = props => {
  const { pauseActivated } = props.getAppStates
  const totalData = props.totalData

  const handleCellClick = () => {
    if (typeof props.onClick === 'function') {
      props.onClick()
    }
  }

  const handleDoubleClick = () => {
    if (typeof props.onDoubleClick === 'function') {
      props.onDoubleClick()
    }
  }

  const getCellClasses = () => {
    let classes = 'regular-cell'

    if (props.selected) {
      classes = classes + ' ' + SELECTED_CLASS
    }

    return classes
  }

  const renderCellContent = () => {
    if (!totalData.details) {
      return <div />
    }

    if (props.dataIds && props.dataIds.length > 0) {
      const Cell = pauseActivated
        ? PausesSubCell
        : SectionsSubCell

      return (
        <Cell
          total={totalData.total}
          details={totalData.details}
          dataIds={props.dataIds}
        />
      )
    }

    return (
      <PartialHandlerSubCell
        data={totalData}
        period={props.period}
        date={props.date}
      />
    )
  }

  const render = () => {
    let content = ''

    if (totalData) {
      content = renderCellContent()
    }

    return (
      <div
        className={getCellClasses()}
      >
        {content}
      </div>
    )
  }

  return (
    <td onClick={handleCellClick} onDoubleClick={handleDoubleClick}>
      {render()}
    </td>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(RegularCell)
